export function Spinner() {
    return (
        <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary/30 border-t-primary" />
        </div>
    )
}
